import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { NavBar, Icon, ListView, Card, WingBlank, WhiteSpace, Picker, List, Modal, Badge, Toast } from 'antd-mobile';
import TipPlaceholder from '../components/TipPlaceholder';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import DataFetcher from '../utils/DataFetcher';
import { createForm } from 'rc-form';
import '../styles/UserCouponUsage.css';
import Constants from '../utils/Constants';
import CommonUtils from '../utils/CommonUtils';

const history = require("history").createHashHistory()
const alert = Modal.alert

class UserCouponUsage extends Component {
    constructor(props) {
        super(props);

        let dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 3 / 4,
            selectedItem: null,
            selectedStatus: 'TO_EXCHANGE',
            deviceTypes: []
        };
    }

    componentDidMount() {
        let height = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop - 135;
        this.setState({
            height
        })
        this.loadDeviceTypes()
        this.loadPageData(1)
    }

    loadDeviceTypes = () => {
        DataFetcher.deviceTypes({}, {
            success: (resp) => {
                this.setState({
                    deviceTypes: resp.data
                })
            }
        })
    }

    loadPageData = (pageNum) => {
        const { selectedStatus } = this.state

        DataFetcher.userCoupons({
            pageNum,
            pageSize: 10,
            status: selectedStatus
        }, {
            success: (resp) => {
                let data = resp.data
                this.pageNum = data.pageNum;
                this.pageSize = data.pageSize;
                this.pages = data.pages;
                let oldRowDatas = this.rowDatas&&pageNum>1 ? this.rowDatas : {}
                this.rowDatas = {...oldRowDatas, ...this.wrapIntoRowDatas(data.result)};
                this.setState({
                    dataSource: this.state.dataSource.cloneWithRows(this.rowDatas),
                    isLoading: false,
                    hasMore: this.pageNum < this.pages,
                })
            }
        })
    }

    onEndReached = (event) => {
        const { isLoading, hasMore } = this.state

        if (isLoading || !hasMore) {
            return;
        }

        this.setState({ isLoading: true });
        this.loadPageData(++this.pageNum)
    }

    onStatusPickerChange = (val) => {
        this.setState({
            selectedStatus: val[0]
        }, () => {
            this.loadPageData(1)
        })
    }

    handleExchangeClick = (rowData) => {
        if(rowData.status !== 'TO_EXCHANGE') {
            return
        }

        if(rowData.activityCouponType === 'GAME_MINUTES') {
            alert('确认要使用该券?', rowData.activityName, [
                { text: '取消', onPress: () => {} },
                { text: '确认', onPress: () => {
                    DataFetcher.exchangeCoupon({
                        couponCode: rowData.couponCode
                    }, {
                        success: (resp) => {
                            Toast.info('兑换中', 3)
                            history.replace(`/user/coupon_result?couponCode=${rowData.couponCode}`)
                        }
                    })
                }},
              ]
            )
        } else if(rowData.activityCouponType === 'PACKET_DISCOUNT') {
            history.push(`/user/coupon_packet?couponCode=${rowData.couponCode}`)
        } else {
            Toast.fail('暂不支持该类型券')
        }
    }

    wrapIntoRowDatas(datas) {
        if (!datas||datas.length<=0) {
            return {};
        }

        let rowDatas = {};
        datas.forEach((data, index) => {
            let id = this.pageNum*this.pageSize + index
            rowDatas[id] = data;
        })
        return rowDatas;
    }

    renderFooter = (isLoading) => {
        if(isLoading) {
            return <LoadingPlaceholder/>
        }

        const { dataSource } = this.state
        if(dataSource.getRowCount()) {
            return <div></div>
        }

        return <TipPlaceholder firstTip='暂无数据'/>
    }

    renderSeparator(sectionId, rowId) {
        return <WhiteSpace key={rowId}/>
    }

    generateInfoColumnForCouponType = (rowData) => {
        let couponType = rowData.activityCouponType
        if(couponType === 'GAME_MINUTES') {
            return (
                <div className='info-column word-ellipsis'>
                    <span className='label'>游戏时间：</span> 
                    <span className='value'>{rowData.gameMinutes}分钟</span>
                </div>
            )
        } else if(couponType === 'PACKET_DISCOUNT') {
            return (
                <div className='info-column word-ellipsis'>
                    <span className='label'>套餐折扣：</span> 
                    <span className='value'>{rowData.discount}%</span>
                </div>
            )
        }
    }

    renderRow = (rowData, sectionId, rowId) => {
        let statusText = rowData.status==='TO_EXCHANGE'?'可用':'已用'
        let statusColor = rowData.status==='TO_EXCHANGE' ? '#04bbc5' : 'gray'
        let statusBadge = (<Badge text={statusText} style={{backgroundColor: statusColor}}/>)
        return (
            <WingBlank size='sm'>
                <div onClick={() => {this.handleExchangeClick(rowData)}}>
                    <Card key={rowId}>
                        <Card.Header
                            title={<span className='word-ellipsis'>{rowData.activityName}</span>}
                            extra={statusBadge}
                        />
                        <Card.Body>
                            <div className='info-row'>
                                {this.generateInfoColumnForCouponType(rowData)}
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>优惠类型：</span> 
                                    <span className='value'>{Constants.DICT_COUPON_TYPE[rowData.activityCouponType]}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column' style={{width: '100%'}}>
                                    <span className='label'>适用门店：</span> 
                                    <span className='value'>{rowData.activitySiteNames&&rowData.activitySiteNames.length?rowData.activitySiteNames.join(','):''}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column' style={{width: '100%'}}>
                                    <span className='label'>卡券描述：</span> 
                                    <span className='value'>{rowData.activityDescription}</span>
                                </div>
                            </div>
                        </Card.Body>
                        <Card.Footer content={<span>{CommonUtils.resolveDictText(rowData.activityDeviceType, this.state.deviceTypes, 'code', 'name')}</span>} extra={<span className='word-ellipsis'>{rowData.modifyTime}</span>}/>
                    </Card>
                </div>
            </WingBlank>
        )
    }

    doRenderFilterView = () => {
        const { selectedStatus } = this.state;
        return (
            <div className='wrapper-filter'>
                <WingBlank size='sm'>
                    <Picker 
                        cols={1}
                        value={[selectedStatus]}
                        onOk={this.onStatusPickerChange}
                        data={CommonUtils.generatePickerOptions(Constants.DICT_USER_COUPON_STATUS)}>
                        <List.Item arrow="horizontal" className='title'>
                            <i className='iconfont icon-guolv'/>
                            <span> 筛选</span>
                        </List.Item>
                    </Picker>
                </WingBlank>
            </div>
        )
    }

    render() {
        const { dataSource, isLoading } = this.state;

        return (
            <div className='page-user-coupon-usage'>
                <NavBar 
                    mode="light" 
                    icon={<Icon type="left" color="black" size="md"/>} 
                    onLeftClick={history.goBack}
                >
                    我的卡券
                </NavBar>
                {this.doRenderFilterView()}
                <ListView
                    ref={el => this.lv = el}
                    dataSource={dataSource}
                    renderFooter={() => this.renderFooter(isLoading)}
                    renderRow={this.renderRow}
                    renderSeparator={this.renderSeparator}
                    pageSize={8}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                    style={{
                        height: this.state.height,
                        overflow: 'auto',
                        paddingTop: 105
                    }}
                />
            </div>
        )
    }
}

export default createForm()(UserCouponUsage);


// WEBPACK FOOTER //
// ./src/modules/UserCouponUsage.js